import cx from 'classnames';
import ReactFormLabel from 'react-bootstrap/FormLabel';
import styles from './FieldLabel.module.scss';

export const FormLabel = (props) => {
  return <ReactFormLabel {...props} className={cx(styles.label, props.className)} />
}